<dialog
  class="general-modal p-0"
  [attr.aria-labelledby]="sessionTimeOutContent.sessionTimeoutMessageTitle"
  [attr.aria-describedby]="
    sessionTimeOutContent.sessionTimeoutMessageDescription
  "
  aria-modal="true"
  role="dialog"
  #sessionTimeoutModal
  id="mach-core-session-timeout"
>
  <div
    class="general-modal-box !rounded-02 w-[343px] tablet:w-full !h-[430px] tablet:!h-[335px]"
  >
    <div
      class="general-modal-content text-heading !overflow-hidden !pb-[24px] tablet:!pb-[25px]"
    >
      <div class="grid" id="mach-core-session-timeout-body">
        <span
          id="mach-core-session-timeout-title"
          class="text-label-xl-semibold !h-[60px] tablet:!h-[30px] mb-[8px] tablet:mb-0"
        >
          {{ sessionTimeOutContent.sessionTimeoutMessageTitle }}
        </span>
        <hr class="text-subtle opacity-03 mt-16 mb-16" />
        <div
          class="pb-[6px] !h-[156px] tablet:!h-[152px]"
          id="mach-core-session-timeout-message-container"
        >
          <p id="mach-core-session-timeout-description" class="text-body-sm">
            {{ sessionTimeOutContent.sessionTimeoutMessageDescription }}
          </p>
          <p
            class="py-16 text-body-xl flex justify-start"
            id="mach-core-session-timeout-timer"
          >
            {{ timer$ | async }}
          </p>
          <p id="mach-core-session-timeout-stay-logged-in" class="text-body-sm">
            {{ sessionTimeOutContent.timeoutStayLogInText }}
          </p>
        </div>
        <div
          class="flex flex-col-reverse w-full gap-8 mt-[6px] tablet:mt-0 tablet:justify-end tablet:flex-row tablet: pr-[4px]"
          id="mach-core-session-timeout-actions"
        >
          <button
            class="button button-secondary button-lg !h-[52px] tablet:!h-[64px] w-[311px] tablet:w-[205px]"
            (click)="logMeOut()"
            id="mach-core-session-timeout-logout-button"
          >
            {{ sessionTimeOutContent.logoutText }}
          </button>
          <button
            class="button button-primary button-lg !h-[52px] tablet:!h-[64px] w-[311px] tablet:w-[205px] tablet:!pl-0 tablet:!pr-0"
            (click)="extendMySession()"
            id="mach-core-session-timeout-extend-button"
          >
            {{ sessionTimeOutContent.loggedInText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</dialog>
